import { render, staticRenderFns } from "./PrfCustomerTemplate.vue?vue&type=template&id=1a0c4045&scoped=true"
import script from "./PrfCustomerTemplate.vue?vue&type=script&lang=js"
export * from "./PrfCustomerTemplate.vue?vue&type=script&lang=js"
import style0 from "./PrfCustomerTemplate.vue?vue&type=style&index=0&id=1a0c4045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0c4045",
  null
  
)

export default component.exports